import { Tabs, Tab, Box } from '@mui/material'
import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import LocationsTable from './locations-table'
import TabPanel from './tab-panel'
import UserTable from './user-table'
import WorkoutCalendar from './workout-calendar'
import WorkoutTypesTable from './workout-types-table'
import WorkoutTable from './workout-table'

type Props = {}
const tabs = [
  'users',
  'workouts',
  'calendar',
  'locations',
  'workout-types',
]

const TableContainer = (props: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const initialTab = tabs.indexOf(searchParams.get('tab') ?? '')
  const [value, setValue] = useState<number>(initialTab >= 0 ? initialTab : 0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    setSearchParams({ tab: tabs[newValue] })
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }
  return (
    <Box width={'100%'}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example">
        <Tab label="Användare" {...a11yProps(0)} />
        <Tab label="Träningspass" {...a11yProps(1)} />
        <Tab label="Kalender" {...a11yProps(2)} />
        <Tab label="Platser" {...a11yProps(3)} />
        <Tab label="Passtyper" {...a11yProps(4)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <UserTable />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <WorkoutTable />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <WorkoutCalendar />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <LocationsTable />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <WorkoutTypesTable />
      </TabPanel>
    </Box>
  )
}

export default TableContainer
